<template>
	<transition name="slide-up-fade" mode="out-in">
		<div
			data-component="iorder-login-modal"
			v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
			v-background-color="$store.getters['ui/getBackgroundColor']"
		>
			<main-header
				data-element="main-header"
				:hideTableNumber="true"
			/>
			<header data-element="subheading">
				<h1
					v-font-style="$store.getters['ui/getHeadingFontDetail']"
					v-color="$store.getters['ui/getPrimaryColor']"
					data-size="xl"
					data-weight="black"
				>
					Your details
				</h1>
				<Icon :icon="'close'" clickable="true" @click.native="$store.dispatch('iOrderCheckout/hideModal')" />
			</header>
			<div
				data-element="text-block"
				v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('light')"
			>
				<p>Almost there! Please enter your details below. </p>
			</div>

			<div
				data-element="user-details"
				v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
				v-background-color="$store.getters['ui/getBackgroundColor']"
			>
				<div data-element="form-wrapper">
					<div data-element="user-form">
						<div data-element="form-row">
							<p
								data-element="field-header"
								v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
							>
								Name
							</p>
							<div
								data-element="input-wrapper"
								:data-error="errors.first('name')"
							>
								<input
								data-element="input"
								placeholder="Your name"
								v-bind:value="name"
								v-on:input="name = $event.target.value"
								v-validate="'required'"
								name="name"
								type="name"
								v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('light')"
								v-modify-input-leading="{ modifyInputLeading: $store.getters['ui/getBodyCopyFontInputLeading'] }"
								/>
							</div>
							<transition name="fade">
								<div
									data-element="error-message"
									v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
									v-show="errors.first('name')"
								>
									{{ errors.first('name') }}
								</div>
							</transition>
						</div>

						<div data-element="form-row">
							<p
								data-element="field-header"
								v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('light')"
							>
								Email Address
							</p>
							<div data-element="input-wrapper">
								<input
								data-element="input"
								placeholder="Your email"
								v-model="email"
								v-validate="'required|verify_email'"
								name="email"
								type="email"
								v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('light')"
								v-modify-input-leading="{ modifyInputLeading: $store.getters['ui/getBodyCopyFontInputLeading'] }"
								/>
							</div>
							<transition name="fade">
								<div
									data-element="error-message"
									v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
									v-show="errors.first('email')"
								>
									{{ errors.first('email') }}
								</div>
							</transition>
						</div>

						<div data-element="form-row">
							<p
								data-element="field-header"
								v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
							>
								Phone number
							</p>
							<div data-element="input-wrapper">
								<input
								data-element="input"
								placeholder="Your phone number"
								v-model="phone"
								v-validate="'required|min:11|max:15'"
								name="phone"
								type="tel"
								v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
								v-modify-input-leading="{ modifyInputLeading: $store.getters['ui/getBodyCopyFontInputLeading'] }"
								/>
							</div>
							<transition name="fade">
								<div
									data-element="error-message"
									v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
									v-show="errors.first('phone')"
								>
									{{ errors.first('phone') }}
								</div>
							</transition>
						</div>

						<div data-element="form-row">
							<btn
								text="Pay"
								:inactive="isDisabled || isSubmitting"
								:loading="isSubmitting"
								size="full"
								:fontStyle="{...this.$store.getters['ui/getBodyCopyFontDetail']('normal'), textSize:'18px'}"
			  				:backgroundColor="$store.getters['ui/getSecondaryColor']"
								@click.native="submit"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>

	import Icon from '@/components/ui/Icon';
	import Btn from '@/components/ui/Btn';
	import MainHeader from '@/components/ui/MainHeader';

	export default {
		props: {
			guestLoginCallback: {
				type: Function,
				default: () => {}
			}
		},
		components: {
			Icon,
			Btn,
			MainHeader
		},
		data () {
			return {
				isSubmitting: false,
				name: '',
				email: '',
				phone: ''
			}
		},
		computed: {
			isDisabled () {
				return !this.name || !this.email || !this.phone || this.errors.items.length
			}
		},
		methods: {
			async submit () {
				if (this.isDisabled || this.isSubmitting) {
					return;
				}
				this.isSubmitting = true
				await this.$store.dispatch('iOrderCheckout/submitGuestDetails', {
					email: this.email,
					name: this.name,
					phone: this.phone
				});
				this.$store.dispatch('iOrderCheckout/hideModal');
				this.guestLoginCallback();
			}
		}
	}

</script>

<style lang="scss" scoped>

@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';
@import '@/assets/scss/iorder-core/form-row.scss';


[data-component='iorder-login-modal'] {
	position:relative;
	width:100%; height:100%;
	background-color:#fff;
	box-shadow:0 2px 4px rgba(0, 0, 0, 0.5);
	@include whenScreenIs(sm) {
		width:400px; height:495px;
	}
	[data-element='subheading'] {
		height: 70px; line-height: 70px;
		font-size: 24px;
		color: $pinkish-red;
		text-align:center;
		position: relative;
		h1 {
			font-weight: 900;
		}
		[data-component="icon"] {
			position: absolute;
			top: 24px; right: 24px;
		}
	}
	[data-element='text-block'] {
		padding: 0 16px;
		margin-bottom:10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	[data-element='user-details'] {
		background:transparent;

		[data-element='form-wrapper'] {
			@include whenScreenIs(sm) {
				display:flex;
				flex-direction:row;
			}

			[data-element='user-form'] {
				@media (min-width: 500px) {
					padding:0 16px 0;
				}
				margin:0 auto;
				padding-bottom: 24px;
				.create-content {
					flex-direction: row;
					margin-bottom: 10px;
					color: $jungle-green;
					strong {
						text-decoration: underline;
						font-weight: 700;
						padding-left: 5px;
					}
				}
			}
		}
		[data-element='form-row'] {
			@extend .form-row;
			height:85px;
			margin-bottom:0;
			justify-content:flex-start;
			[data-element='field-header'] {
				margin-bottom:0;
			}
			[data-element='input-wrapper'] {
				position:relative;
				&[data-error] {
					border-color:#cc1013;
				}
				[data-element='input'] {
					&:focus::-webkit-input-placeholder { color:transparent; }
					&:focus:-moz-placeholder { color:transparent; } /* FF 4-18 */
					&:focus::-moz-placeholder { color:transparent; } /* FF 19+ */
					&:focus:-ms-input-placeholder { color:transparent; } /* IE 10+ */
				}
				[data-component='icon'] {
					position:absolute;
					right:8px;
					top:12px;
				}
			}
			[data-element='error-message'] {
				margin-top:3px;
			}
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition-duration: 1s;
	transition-property: opacity;
	transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
	opacity: 0
}

</style>
